import { bl_fi_nsti_stock_txn_line_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class NstiStockTxnLineContainerModel extends BaseContainerModel {
  bl_fi_nsti_stock_txn_line: bl_fi_nsti_stock_txn_line_RowClass = new bl_fi_nsti_stock_txn_line_RowClass();
}